module.exports = __webpack_public_path__ + "img/mood_sad.8f64cac5.png";